import { firebaseDevConfig, firebaseProdConfig } from "../app/firebase.init";

export const environment = {
  production: false,
  firebaseConfig: firebaseDevConfig
};
